<template>
  <cube-page
    class="info-show"
    title="修改密码">
    <div slot="content">
      <cube-form
        style="width: 90%;margin-left: 15px;margin-top: 20px"
        :model="modifyForm"
      >
        <cube-form-group>
          <cube-form-item :field="field[0]"></cube-form-item>
          <cube-form-item :field="field[1]"></cube-form-item>
          <cube-form-item :field="field[2]"></cube-form-item>
        </cube-form-group>
        <cube-form-group>
          <cube-button style="margin-bottom: 20px;margin-top: 15px" @click="handleSubmit">确定</cube-button>
        </cube-form-group>
        <cube-form-group>
          <cube-button @click="handleCancel">取消</cube-button>
        </cube-form-group>
      </cube-form>
    </div>

  </cube-page>
</template>

<script>
/**
 * 个人信息组件
 * @author Sky
 */
import { mapGetters } from 'vuex'
import personalDetailsApi from '@/api/personalDetails'
import CubePage from '../../components/cube-page'
import { asyncLoginOut } from '@/api/auth'

export default {
  name: 'EditPassword',
  components: { CubePage },
  data () {
    return {
      validity: {},
      valid: undefined,
      areaList: [],
      modifyForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      field: [
        {
          type: 'input',
          modelKey: 'oldPassword',
          label: '旧的密码',
          props: {
            placeholder: '请输入'
          }
        },
        {
          type: 'input',
          modelKey: 'newPassword',
          label: '新的密码',
          props: {
            placeholder: '请输入'
          }
        }, {
          type: 'input',
          modelKey: 'confirmPassword',
          label: '确认密码',
          props: {
            placeholder: '请输入'
          }
        }],

      options: {
        scrollToInvalidField: true,
        layout: 'standard' // classic fresh
      },
      orgList: [],
      companyList: [],
      drugList: [],
      editModel: {
        realName: '',
        email: '',
        mobileNum: ''
      },

      userData: {},
      clearable: {
        visible: true,
        blurHidden: true
      }
    }
  },
  computed: {
    ...mapGetters(['identifier', 'userId'])
  },
  filters: {
    filterName (list) {
      if (list === undefined) {
        return
      }
      return list.map((item) => item.name).toString()
    }
  },
  mounted () {
    const vm = this
    vm.editModel.realName = vm.userData.realName // 初始化姓名
    this.editModel.email = vm.userData.email
    this.editModel.mobileNum = vm.userData.mobile
  },
  methods: {
    handleModifyPassword () {
      this.modifyForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    handleCancel () {
      this.modifyForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    handleSubmit () {
      const vm = this
      const { oldPassword, newPassword, confirmPassword } = vm.modifyForm
      let message = ''
      if (newPassword !== confirmPassword) {
        message = '您两次输入的密码不一致，请核对后重新输入'
      } else if (!oldPassword) {
        message = '请输入旧密码'
      } else if (!newPassword) {
        message = '请输入新密码'
      } else if (oldPassword === newPassword) {
        message = '旧密码与新密码不能重复'
      }
      if (message) {
        vm.$createDialog({
          title: '提示',
          type: 'alert',
          content: message
        }).show()
        return
      }
      const data = {
        newPassword: vm.modifyForm.newPassword,
        oldPassword: vm.modifyForm.oldPassword
      }
      personalDetailsApi.accountPasswordModify(data).then((response) => {
        if (response.code === 1) {
          vm.$createDialog({
            title: '提示',
            type: 'success',
            content: '密码修改成功！即将重新登录',
            onConfirm: () => {
              // 百度统计事件追踪
              this.$store.dispatch('PushHmtTrackEvent', {
                category: '退出登录',
                action: '点击'
              })
              // 上报操作日志
              this.$store
                .dispatch('PushUserLog', {
                  menu: '修改密码',
                  page: '修改密码',
                  operation: '退出登录'
                })
                .then(() => {
                  // 接口退出登录
                  asyncLoginOut()
                    .then(() => {
                      // 清除token
                      this.$store.dispatch('LoginOut')
                      this.$router.replace({ name: 'login' })
                    })
                    .catch(() => {
                      // 清除token
                      this.$store.dispatch('LoginOut')
                      this.$router.replace({ name: 'login' })
                    })
                })
                .catch(() => {
                  /// 接口退出登录
                  asyncLoginOut()
                    .then(() => {
                      // 清除token
                      this.$store.dispatch('LoginOut')
                      this.$router.replace({ name: 'login' })
                    })
                    .catch(() => {
                      // 清除token
                      this.$store.dispatch('LoginOut')
                      this.$router.replace({ name: 'login' })
                    })
                })
            }
          }).show()
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.popover-box {
    max-height: 600px;
    overflow: auto;
}

.el-popover .el-tag {
    margin-left: 10px;
    margin-bottom: 10px;
    background-color: rgba(144, 147, 153, 0.1);
    border-color: rgba(144, 147, 153, 0.2);
    color: rgb(144, 147, 153);
}

.el-tag-content {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
